<div class="d-flex align-items-center">
  <ng-container *ngIf="iconConfig?.icon; else textView">
    <div
      class="driver-status-icon icon-view d-flex align-items-center justify-content-center"
      [ngStyle]="{ color: iconConfig[currentThemeSubject | async]?.color }"
    >
      <fb-icon *ngIf="!iconConfig?.externalIcon" [width]="24" [iconName]="iconConfig?.icon"></fb-icon>
      <mat-icon *ngIf="iconConfig?.externalIcon" fontSet="material-symbols-outlined">{{ iconConfig?.icon }}</mat-icon>
    </div>
  </ng-container>
  <ng-template #textView>
    <div
      class="driver-status-icon text-view"
      [class.with-count]="count !== undefined && count !== null"
      [ngStyle]="{
        'background-color': iconConfig[currentThemeSubject | async]?.bg,
        color: iconConfig[currentThemeSubject | async]?.color
      }"
    >
      <span>{{ iconConfig?.text }}</span>
      <span *ngIf="count !== undefined && count !== null">: {{ count }}</span>
    </div>
  </ng-template>
</div>
